// ApprovalDialog.js

import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

const ApprovalDialog = ({ open, onClose, onApprove, title, yesBtnText = "Yes", noBtnText = "No" }) => {
    const [approvalRemark, setApprovalRemark] = useState('');

    const handleApprove = () => {
        onClose();
        onApprove(approvalRemark);
    };

    return (
        <Dialog maxWidth="md" open={open} onClose={onClose}>
            <div className="p-8 text-center mx-auto" style={{ width: 500 }}>
                <h4 className="capitalize m-0 mb-4">{title}</h4>
                <ValidatorForm>
                    <TextValidator
                        value={approvalRemark}
                        onChange={(e) => setApprovalRemark(e.target.value ?? '')}
                        placeholder="Add your remarks here"
                        fullWidth
                        multiline
                        rows={5}
                        variant="outlined"
                        size="small"
                    />
                </ValidatorForm>
                <div className="flex justify-center pt-4 m--2">
                    <Button
                        className="m-2 rounded hover-bg-primary px-6"
                        variant="outlined"
                        color="primary"
                        onClick={handleApprove}
                    >
                        {yesBtnText}
                    </Button>
                    <Button
                        className="m-2 rounded hover-bg-secondary px-6"
                        variant="outlined"
                        color="secondary"
                        onClick={onClose}
                    >
                        {noBtnText}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default ApprovalDialog;
